import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const GetClientsMedicalPlanFundingType = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_MEDICAL_PLAN_FUNDING_TYPE, token)
  return res;
};

export const GetClientsMedicalPlanStopLossInsurer = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_MEDICAL_PLAN_STOP_LOSS, token)
  return res;
};

export const GetClientsMedicalPlanType = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_MEDICAL_PLAN_TYPE, token)
  return res;
};

export const SaveClientsMedicalPlanDetails = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_CLIENT_MEDICAL_PLAN_DETAILS, payload, token)
  return res;
};

export const GetClientsMedicalPlanDetails = async(clientId, userId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CLIENT_MEDICAL_PLAN_DETAILS + `ClientID=${clientId}&UserID=${userId}`, token)
  return res;
};

export const GetClientsMedicalPlanDetailsByID = async (clientId, userId, CMedicalPlanID) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CLIENT_MEDICAL_PLAN_DETAILS_BY_ID +
    `ClientID=${clientId}&UserID=${userId}&CMedicalPlanID=${CMedicalPlanID}`,
    token
  );
  return res;
};

export const GetFeeByFundingArrangement = async (categoryId, fundingId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_FEE_BY_FUNDING_ARRANGEMENT +
    `CategoryID=${categoryId}&&FundingID=${fundingId}`,
    token
  );
  return res;
};

export const GetSubFeeByMainFee = async (categoryId, fundingId, feeId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_SUB_FEE_BY_MAIN_FEE +
    `CategoryID=${categoryId}&FundingID=${fundingId}&FeeID=${feeId}`,
    token
  );
  return res;
};

export const GetFeeType = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_FEE_TYPE, token
  );
  return res;
};
